/**
 * Processes a collection in intermittent batches.
 * @param collection - The array to be processed.
 * @param iterator - The function to apply to each element in the collection.
 * @param batchSize - The number of items to process in each batch.
 * @param onDone - The callback to execute after processing all batches.
 * @param startAt - The index to start processing from. Defaults to 0.
 */
export function intermittentLoop<T>(
    collection: T[],
    iterator: (value: T, index: number) => void,
    batchSize: number = 10, // Default batchSize
    onDone: () => void,
    startAt: number = 0
) {
    // Calculate the stopping condition for the loop
    const stop = Math.min(startAt + batchSize, collection.length);

    // Process the batch
    for (let i = startAt; i < stop; i++) {
        try {
            iterator(collection[i], i);
        } catch (error) {
            console.error(`Error processing item at index ${i}:`, error);
        }
    }

    // Schedule the next batch or call the onDone callback
    if (stop < collection.length) {
        setTimeout(() => intermittentLoop(collection, iterator, batchSize, onDone, stop), 0);
    } else {
        onDone();
    }
}
